import React, { Component } from 'react';
import HttpsRedirect from 'react-https-redirect';
import GeoLocation from './GeoLocation';
import Bar from './Bar';


import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';



class Main extends Component {
   
    render(){
        return(
            <MuiThemeProvider  >
				<HttpsRedirect>
					<div  >
						<Bar/>
						<GeoLocation {...this.props} />
					</div>
				</HttpsRedirect>
            </MuiThemeProvider>
        )
    }
}
export default Main;





// WEBPACK FOOTER //
// ./src/Main.js